
/***************************************************************
                You saved XY Feature

  Displays the difference between the total cart amount and
  the total compare at price in the ajax cart

***************************************************************/                
console.log('savingsXY.js init');

function updateJSCart() {

    Knocking.JSCart = [];
    Knocking.loadCart(callback_Handles_Quantity);
    

    }

//Callback function mapping handles and quantities to Knocking.JSCart
function callback_Handles_Quantity(response) {
  
  for( i = 0; i < response.items.length; i++ ) {
    Knocking.JSCart.push({"handle": response.items[i].handle, "quantity": response.items[i].quantity});

  }
  
  Knocking.total_price = response.total_price;
  //console.log(total_price);
  loadVariants(callbackCompareAtPrice);

  //updateKnocking.JSCart(response);
};



//Fetching the single products from the Shopify Ajax-API using the handles
function loadVariants(callback) {
     
  for ( i = 0; i < Knocking.JSCart.length; i++ ) {
    
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        
        callback(JSON.parse(this.responseText));
          
        
      }
    }

    xhr.open("GET", "../products/" + Knocking.JSCart[i].handle + ".js", true);
    xhr.send();

    
  }

  //console.log(Knocking.JSCart);

};


//Callback function mappind compare_at_price 's to their items in Knocking.JSCart
function callbackCompareAtPrice(response) {
    
  for ( i = 0; i < Knocking.JSCart.length; i++) {
    if ( Knocking.JSCart[i].handle === response.handle ) {
      Knocking.JSCart[i].compare_at_price = response.compare_at_price;
    }
  }
  //console.log(Knocking.JSCart);
  updatePage();
  
  
};


//Updates HTML



function updatePage() {
  //console.log(Knocking.JSCart);
  let compPriceTotal = 0;
  let savings = 0;

  for ( i = 0; i < Knocking.JSCart.length; i++ ) {
    
    //console.log(Knocking.JSCart[i].quantity);
    //console.log(Knocking.JSCart[i].compare_at_price);

    if (Knocking.JSCart[i].compare_at_price) {
      compPriceTotal = compPriceTotal +  (Knocking.JSCart[i].quantity * Knocking.JSCart[i].compare_at_price) ;
     
    }
    
    //console.log('Comp: ' + compPriceTotal);
   
  }

  
  savings = new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2 } ).format((compPriceTotal - Knocking.total_price) / 100 );
  //console.log('Total: ' + Knocking.total_price);
  //console.log('Savings: ' + savings);
  
  if ( savingsXyEnable == "true" ) {
    if ( compPriceTotal > Knocking.total_price ) {
      $('#savings').html("<span>You are saving $</span>" +  savings + "<span>!</span>");  
    }
  } else {
    $('#savings').css('display', 'none')
  }
  
  
}

window.onload = updateJSCart();

/************************************************************************************************************************/